import { QUERY_KEYS } from '../../../../../consts';
import { getSinglePatientAttachedFilesService } from '../../../../../services';
import { getAtomWithMutation } from '../../../../../utils';

export const getSinglePatientAttachedFilesAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.PATIENTS.ALL_PATIENTS_ATTACHED_FILES,
  mutationFn: () => getSinglePatientAttachedFilesService,
});
